<template>
  <v-container fluid grid-list-xl>
    <v-layout wrap align-start>
      <v-flex sm2 d-flex v-if="role === 'Admin'">
        <v-select
          v-model="leadFilters.agent"
          :items="agents"
          :loading="loadingAgents"
          item-text="fullname"
          item-value="id"
          label="Agent"
          @change="filter"
          chips
          multiple
          dense
          solo
        >
          <template v-slot:selection="{ item, index }">
            <v-chip v-if="index === 0">
              <span>{{ item.fullname }}</span>
            </v-chip>
            <span v-if="index === 1" class="grey--text caption">
              (+{{ leadFilters.agent.length - 1 }})
            </span>
          </template>
          <template v-slot:prepend-item>
            <v-list-item ripple @click="selectAllAgents">
              <v-list-item-action>
                <v-icon
                  :color="leadFilters.agent.length > 0 ? 'indigo darken-4' : ''"
                >
                  {{ agentIcon }}
                </v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Select All </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
          </template>
        </v-select>
      </v-flex>
      <v-flex sm2 d-flex>
        <v-select
          v-model="leadFilters.status"
          :items="statuses"
          :loading="loadingStatuses"
          item-text="title"
          item-value="id"
          label="Status"
          @change="filter"
          chips
          multiple
          dense
          solo
        >
          <template v-slot:selection="{ item, index }">
            <v-chip v-if="index === 0">
              <span>{{ item.title }}</span>
            </v-chip>
            <span v-if="index === 1" class="grey--text caption">
              (+{{ leadFilters.status.length - 1 }})
            </span>
          </template>
          <template v-slot:prepend-item>
            <v-list-item ripple @click="selectAllStatuses">
              <v-list-item-action>
                <v-icon
                  :color="
                    leadFilters.status.length > 0 ? 'indigo darken-4' : ''
                  "
                >
                  {{ statusIcon }}
                </v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Select All </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
          </template>
        </v-select>
      </v-flex>
      <v-flex sm2 d-flex>
        <v-select
          v-model="leadFilters.source"
          :items="sources"
          :loading="loadingSources"
          item-text="title"
          item-value="id"
          label="Source"
          @change="filter"
          dense
          solo
        >
        </v-select>
      </v-flex>
      <v-flex sm2 d-flex>
        <v-select
          v-model="leadFilters.state"
          :items="states"
          :loading="loadingStates"
          item-text="title"
          item-value="id"
          label="State"
          @change="filter"
          chips
          multiple
          dense
          solo
        >
          <template v-slot:selection="{ item, index }">
            <v-chip v-if="index === 0">
              <span>{{ item.title }}</span>
            </v-chip>
            <span v-if="index === 1" class="grey--text caption">
              (+{{ leadFilters.state.length - 1 }})
            </span>
          </template>
          <template v-slot:prepend-item>
            <v-list-item ripple @click="selectAllStates">
              <v-list-item-action>
                <v-icon
                  :color="leadFilters.state.length > 0 ? 'indigo darken-4' : ''"
                >
                  {{ stateIcon }}
                </v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Select All </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
          </template>
        </v-select>
      </v-flex>
      <v-flex sm2 d-flex>
        <v-btn height="40" depressed @click="clearFilters">
          Clear filters
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
  computed: {
    ...mapGetters({
      statuses: "statuses/statuses",
      loadingStatuses: "statuses/loadingStatuses",
      states: "states/states",
      loadingStates: "states/loadingStates",
      agents: "agents/agents",
      loadingAgents: "agents/loadingAgents",
      sources: "sources/sources",
      loadingSources: "sources/loadingSources",
      leads: "leads/leads",
      loadingLeads: "leads/loadingLeads",
      leadFilters: "filters/leadFilters",
      role: "auth/role",
      user: "auth/user",
    }),
    agentIcon() {
      if (this.leadFilters.agent.length === this.agents.length)
        return "mdi-close-box";
      if (
        this.leadFilters.agent.length < this.agents.length &&
        this.leadFilters.agent.length > 0
      )
        return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    statusIcon() {
      if (this.leadFilters.status.length === this.statuses.length)
        return "mdi-close-box";
      if (
        this.leadFilters.status.length < this.statuses.length &&
        this.leadFilters.status.length > 0
      )
        return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    stateIcon() {
      if (this.leadFilters.state.length === this.states.length)
        return "mdi-close-box";
      if (
        this.leadFilters.state.length < this.states.length &&
        this.leadFilters.state.length > 0
      )
        return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
  },
  created() {
    this.switchRoom();
  },
  methods: {
    ...mapMutations({
      SET_STATE_FILTER: "filters/SET_STATE_FILTER",
      SET_STATUS_FILTER: "filters/SET_STATUS_FILTER",
      SET_AGENT_FILTER: "filters/SET_AGENT_FILTER",
      SET_SOURCE_FILTER: "filters/SET_SOURCE_FILTER",
    }),
    ...mapActions({
      loadLeadsByFilters: "leads/loadLeadsByFilters",
    }),
    switchRoom() {
      this.$socket.emit("join_leads_type", {
        type: this.leadFilters.type,
      });
      if (this.role === "Admin") {
        switch (this.leadFilters.source) {
          case 1:
            this.$socket.emit("join_blueberry_leads", this.leadFilters.type);
            break;
          case 2:
            this.$socket.emit("join_mediaalpha_leads", this.leadFilters.type);
            break;
          case 3:
            this.$socket.emit("join_manual_leads", this.leadFilters.type);
            break;
          case 4:
            this.$socket.emit("join_bulk_leads", this.leadFilters.type);
            break;
          case 5:
            this.$socket.emit(
              "join_clickListing_leads",
              this.leadFilters.type
            );
            break;
          case 6:
            this.$socket.emit(
              "join_liveTransfer_leads",
              this.leadFilters.type
            );
            break;
        }
      } else if (this.role === "Agent") {
        this.$socket.emit("join_agent_leads", {
          source: this.leadFilters.source,
          type: this.leadFilters.type,
          user_id: this.user.id,
        });
      }
    },
    filter() {
      this.switchRoom();
      this.SET_STATE_FILTER(this.leadFilters.state);
      this.SET_STATUS_FILTER(this.leadFilters.status);
      this.SET_AGENT_FILTER(this.leadFilters.agent);
      this.SET_SOURCE_FILTER(this.leadFilters.source);
      this.loadLeadsByFilters({params: this.leadFilters});
    },
    selectAllAgents() {
      if (this.leadFilters.agent.length === this.agents.length) {
        this.leadFilters.agent = [];
      } else {
        this.setAllAgents();
      }
      this.SET_AGENT_FILTER(this.leadFilters.agent);
      this.loadLeadsByFilters({params: this.leadFilters});
    },
    selectAllStatuses() {
      if (this.leadFilters.status.length === this.statuses.length) {
        this.leadFilters.status = [];
      } else {
        this.setAllStatuses();
      }
      this.SET_STATUS_FILTER(this.leadFilters.status);
      this.loadLeadsByFilters({params: this.leadFilters});
    },
    selectAllStates() {
      if (this.leadFilters.state.length === this.states.length) {
        this.leadFilters.state = [];
      } else {
        this.setAllStates();
      }
      this.SET_STATE_FILTER(this.leadFilters.state);
      this.loadLeadsByFilters({params: this.leadFilters});
    },
    clearFilters() {
      this.setAllStatuses();
      this.setAllStates();
      this.leadFilters.source = 2;

      if (this.role === "Agent") {
        this.leadFilters.agent = [this.user.id];
      } else {
        this.setAllAgents();
      }

      this.SET_STATE_FILTER(this.leadFilters.state);
      this.SET_STATUS_FILTER(this.leadFilters.status);
      this.SET_AGENT_FILTER(this.leadFilters.agent);
      this.SET_SOURCE_FILTER(this.leadFilters.source);
      this.loadLeadsByFilters({params: this.leadFilters});
    },
    setAllStates() {
      this.leadFilters.state = [];
      this.states.forEach((state) => {
        this.leadFilters.state.push(state.id);
      });
    },
    setAllAgents() {
      this.leadFilters.agent = [];
      this.agents.forEach((agent) => {
        this.leadFilters.agent.push(agent.id);
      });
    },
    setAllStatuses() {
      this.leadFilters.status = [];
      this.statuses.forEach((status) => {
        this.leadFilters.status.push(status.id);
      });
    },
  },
  name: "LeadTableFilter",
};
</script>

<style scoped>
</style>